import { useState, useEffect } from "react";

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    const pulseTimer = setInterval(() => setPulse((p) => !p), 3000);
    return () => {
      clearTimeout(timer);
      clearInterval(pulseTimer);
    };
  }, []);

  return (
    <a
      href="https://wa.me/237678012159?text=Hello%20Creative%20Hub!%20I%27d%20like%20to%20place%20an%20order."
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-2 transition-all duration-500 cursor-pointer group ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      {/* Tooltip */}
      <span className="hidden group-hover:flex items-center px-3 py-1.5 bg-white text-green-700 text-xs font-semibold rounded-full shadow-lg whitespace-nowrap border border-green-100 transition-all duration-200">
        Chat with us!
      </span>

      {/* Button */}
      <div className="relative">
        {/* Pulse rings */}
        <span className={`absolute inset-0 rounded-full bg-green-400 transition-all duration-1000 ${pulse ? "scale-150 opacity-0" : "scale-100 opacity-30"}`} />
        <span className={`absolute inset-0 rounded-full bg-green-400 transition-all duration-1000 delay-300 ${pulse ? "scale-125 opacity-0" : "scale-100 opacity-20"}`} />

        <div className="relative w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-green-400 to-emerald-600 shadow-xl hover:scale-110 transition-transform duration-200">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </div>
      </div>
    </a>
  );
}